import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const ProspectsModelSchema = z
  .object({
    id: z.string(),
    investor: z.string().nullish(),
    fund: z.string().nullish(),
    currency: z.string().nullish(),
    commitment: z.number().nullish(),
    allocation_available: z.number().nullish(),
    pipeline_origination: z.string().nullish(),
    pipeline_execution: z.string().nullish(),
    notes: z.string().nullish()
  })
  .strict()

export const ProspectsModelFields = makeFieldKeys(ProspectsModelSchema)

export type ProspectsModel = z.infer<typeof ProspectsModelSchema>

function validateProspectsModel(data: unknown): ProspectsModel {
  try {
    return validateWithZodSchema(ProspectsModelSchema, data, 'prospects model')
  } catch (error) {
    throw new Error(`Prospects model validation failed: ${error}`)
  }
}
